import { Cached, Route } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";
import { useClearProductionCache, useClearStaleRoutes } from "@ryde/redux";

import { StyledButtonContainer } from "./controls.panels.styled";

export const ClearCachePanel: FC = () => {
  useTranslation();
  const { handleClearProductionCacheClick } = useClearProductionCache();
  const { handleClearStaleRoutesClick } = useClearStaleRoutes();

  return (
    <StyledButtonContainer>
      <h2>Service functions</h2>
      <MuiButton
        onClick={() => handleClearProductionCacheClick()}
        muiStyle="info"
        startIcon={<Cached />}
      >
        Clear application cache
      </MuiButton>
      <MuiButton
        onClick={() => handleClearStaleRoutesClick()}
        muiStyle="success"
        startIcon={<Route />}
      >
        Clear stale routes
      </MuiButton>
    </StyledButtonContainer>
  );
};
